<template>
  <v-snackbar
    v-model="visible"
    :color="color"
    :timeout="3000"
    top
    centered
    :class="animar ? 'snackbar-zumbido' : ''"
    @input="onSnackbarChange"
  >
    {{ mensaje }}
  </v-snackbar>
</template>

<script>
export default {
  name: "SnackbarSms",
  data() {
    return {
      visible: false,
      mensaje: '',
      color: '',
      animar: false,
      queue: [],
      mostrando: false,
    };
  },
  methods: {
    mostrarMensaje(exito, nombrePaciente = '') {
      this.queue.push({ exito, nombrePaciente });

      // Reinicia si no está procesando actualmente
      if (!this.mostrando) {
        this.procesarCola();
      }
    },
    async procesarCola() {
      if (this.queue.length === 0) {
        this.mostrando = false; // ✅ Solución al atasco
        return;
      }

      this.mostrando = true;

      const { exito, nombrePaciente } = this.queue.shift();
      this.mensaje = exito
        ? `SMS enviado correctamente a ${nombrePaciente}.`
        : `No se pudo enviar el SMS a ${nombrePaciente}. Intente nuevamente más tarde.`;
      this.color = exito ? 'green' : 'red';
      this.animar = false;

      this.$nextTick(() => {
        this.animar = true;
        this.visible = true;
      });

      // Esperar un poco más que el timeout visual para evitar superposición
      await new Promise(resolve => setTimeout(resolve, 3200));

      this.visible = false;

      // Esperar a que desaparezca
      await new Promise(resolve => setTimeout(resolve, 300));

      // Procesar el siguiente mensaje en la cola
      this.procesarCola();
    },
    cerrar() {
      this.visible = false;
    },
    onSnackbarChange(val) {
      if (!val) this.animar = false;
    }
  }
};
</script>

<style scoped>
@keyframes zumbido {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
}

.snackbar-zumbido {
  animation: zumbido 0.4s ease;
}
</style>
